import { ofType } from "redux-observable";
import { switchMap, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { from } from "rxjs"; // NEW: Import from for Promise handling
import { ActionsObservable } from "redux-observable";
import { toast } from "react-toastify";
import { API_URL } from "../../config/settings";
import { Headers } from "../../utilites/Headers";
import { uploadFile } from "../../utilites/files"; // NEW: Import uploadFile
import { PropertiesStats } from "../../actions/appExpandedActions/properties";

// Aggregated Stats Epic
export const getPropertiesAggregatedStatsEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_PROPERTIES_AGGREGATED_STATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/aggregated-stats`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Properties Aggregated Stats Response:", response);
            obs.next({
              type: PropertiesStats.GET_PROPERTIES_AGGREGATED_STATS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Properties Aggregated Stats Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load properties stats");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Rent Payments Epic - FIX: Use correct endpoint
export const getRentPaymentsEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_RENT_PAYMENTS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/rent-payments/list`, // ✅ Correct endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          property: payload?.property || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Rent Payments Response:", response);
            obs.next({
              type: PropertiesStats.GET_RENT_PAYMENTS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Rent Payments Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load rent payments");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// DataTable filter key -> request body field
const UTILITY_BILL_FILTER_FIELDS = {
  user: "fullName",
  provider: "provider",
  clientNumber: "clientNumber",
  hasReceipt: "hasReceipt",
};

const buildUtilityBillPaymentsBody = (payload) => {
  const filters = payload?.filters || {};
  const filterFields = Object.entries(UTILITY_BILL_FILTER_FIELDS).reduce((acc, [filterKey, field]) => {
    const value = filters[filterKey];
    acc[field] = typeof value === "string" ? value.trim() : value ?? "";
    return acc;
  }, {});

  const toAmount = (value) => {
    const amount = value === "" || value === null || value === undefined ? NaN : Number(value);
    return Number.isFinite(amount) ? amount : "";
  };

  return {
    page: payload?.page || 1,
    limit: payload?.limit || 20,
    startDate: payload?.startDate || "",
    endDate: payload?.endDate || "",
    ...filterFields,
    epayStatuses: filters.epayStatus ? [filters.epayStatus] : [],
    amountMin: toAmount(filters.amount?.min),
    amountMax: toAmount(filters.amount?.max),
  };
};

export const getUtilityBillPaymentsEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_UTILITY_BILL_PAYMENTS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/utility-bills/payments/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(buildUtilityBillPaymentsBody(payload)),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: PropertiesStats.GET_UTILITY_BILL_PAYMENTS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Utility Bills Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load utility payments");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Property Files Epic - FIX: Use correct endpoint
export const getPropertyFilesEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_PROPERTY_FILES),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/files/list`, // ✅ Correct endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Property Files Response:", response);
            obs.next({
              type: PropertiesStats.GET_PROPERTY_FILES_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Property Files Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load property files");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Property Calendar Epic - FIX: Use correct endpoint
export const getPropertyCalendarEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_PROPERTY_CALENDAR),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/events/list`, // ✅ Fixed endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Property Calendar Response:", response);
            obs.next({
              type: PropertiesStats.GET_PROPERTY_CALENDAR_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Property Calendar Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load calendar events");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Property Chats Epic - FIX: Use correct endpoint
export const getPropertyChatsEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_PROPERTY_CHATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/chats/list`, // ✅ Correct endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Property Chats Response:", response);
            obs.next({
              type: PropertiesStats.GET_PROPERTY_CHATS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Property Chats Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load property chats");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Property Queries Epic - FIX: Use correct endpoint
export const getPropertyQueriesEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_PROPERTY_QUERIES),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/assistant-queries/list`, // ✅ Fixed endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Property Queries Response:", response);
            obs.next({
              type: PropertiesStats.GET_PROPERTY_QUERIES_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Property Queries Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load property queries");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Property Invitations Epic - FIX: Use correct endpoint
export const getPropertyInvitationsEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_PROPERTY_INVITATIONS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/mutual-management-invitations/list`, // ✅ Fixed endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Property Invitations Response:", response);
            obs.next({
              type: PropertiesStats.GET_PROPERTY_INVITATIONS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Property Invitations Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load property invitations");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Add missing folders epic
export const getPropertyFoldersEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_PROPERTY_FOLDERS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/folders/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Property Folders Response:", response);
            obs.next({
              type: PropertiesStats.GET_PROPERTY_FOLDERS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Property Folders Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load property folders");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Landlord Tenant Invitations Epic
export const getLandlordTenantInvitationsEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_LANDLORD_TENANT_INVITATIONS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/landlord-tenant/invitations/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          page: payload?.page || 1,
          limit: payload?.limit || 10,
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Landlord Tenant Invitations Response:", response);
            obs.next({
              type: PropertiesStats.GET_LANDLORD_TENANT_INVITATIONS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Landlord Tenant Invitations Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load landlord-tenant invitations");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// Shared Management Invitations Epic
export const getSharedManagementInvitationsEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.GET_SHARED_MANAGEMENT_INVITATIONS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-properties/shared-management/invitations/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          page: payload?.page || 1,
          limit: payload?.limit || 10,
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            console.log("🎯 Shared Management Invitations Response:", response);
            obs.next({
              type: PropertiesStats.GET_SHARED_MANAGEMENT_INVITATIONS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            console.error("❌ Shared Management Invitations Error:", err);
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load shared management invitations");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

// ✅ NEW: Mark Utility Bill as Paid Epic
export const markUtilityBillAsPaidEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.MARK_UTILITY_BILL_AS_PAID),
    switchMap(({ payload }) => {
      console.log("🔄 Mark as Paid Epic - Payload received:", payload);
      
      const billId = payload?.payment || payload?.billId;
      console.log("📋 Payment ID:", billId);
      
      // Check if we have a file to upload
      if (payload?.receiptFile) {
        console.log("📎 Uploading receipt file:", payload.receiptFile.name);
        
        // Step 1: Upload the file first to get the URL
        return from(uploadFile(payload.receiptFile)).pipe(
          switchMap((uploadResult) => {
            console.log("✅ File upload successful:", uploadResult);
            const receiptUrl = uploadResult.location;
            console.log("🔗 Using receipt URL:", receiptUrl);
            
            // Step 2: Call the mark-as-paid API with the uploaded file URL
            return ajax({
              url: `${API_URL}/admin/utility-bills/mark-as-paid`,
              method: "POST",
              headers: Headers.get_auth(), // Use JSON headers since we're sending JSON now
              body: JSON.stringify({
                payment: billId,
                receiptUrl: receiptUrl
              }),
            }).pipe(
              switchMap(({ response }) =>
                ActionsObservable.create((obs) => {
                  console.log("🎯 Mark Utility Bill as Paid Response:", response);
                  obs.next({
                    type: PropertiesStats.MARK_UTILITY_BILL_AS_PAID_SUCCESS,
                    payload: {
                      billId: billId,
                      updatedBill: response.payload || response.data,
                    },
                  });
                  if (payload?.onSuccess) payload.onSuccess(response);
                  toast.success("Utility bill marked as paid successfully");
                  obs.complete();
                })
              ),
              catchError((err) =>
                ActionsObservable.create((obs) => {
                  console.error("❌ Mark Utility Bill as Paid API Error:", err);
                  if (err.status === 401) {
                    localStorage.clear();
                    window.location.href = "/login";
                  }
                  toast.error(err?.response?.error || "Failed to mark utility bill as paid");
                  if (payload?.onError) payload.onError(err);
                  obs.complete();
                })
              )
            );
          }),
          catchError((err) => {
            console.error("❌ File Upload Error:", err);
            return ActionsObservable.create((obs) => {
              toast.error("Failed to upload receipt file");
              if (payload?.onError) payload.onError(err);
              obs.complete();
            });
          })
        );
      } else {
        console.log("⚠️ No receipt file provided");
        return ActionsObservable.create((obs) => {
          toast.error("Receipt file is required");
          if (payload?.onError) payload.onError(new Error("Receipt file is required"));
          obs.complete();
        });
      }
    })
  );

// ✅ NEW: Upload Utility Bill Receipt Epic
export const uploadUtilityBillReceiptEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.UPLOAD_UTILITY_BILL_RECEIPT),
    switchMap(({ payload }) => {
      console.log("🔄 Upload Receipt Epic - Payload received:", payload);
      
      const billId = payload?.payment || payload?.billId;
      console.log("📋 Payment ID:", billId);
      
      // Create FormData for file upload if file is provided
      if (payload?.receiptFile) {
        console.log("📎 Uploading receipt file:", payload.receiptFile.name);
        
        // Step 1: Upload the file first to get the URL
        return from(uploadFile(payload.receiptFile)).pipe(
          switchMap((uploadResult) => {
            console.log("✅ File upload successful:", uploadResult);
            const receiptUrl = uploadResult.location;
            console.log("🔗 Using receipt URL:", receiptUrl);
            
            // Step 2: Call the upload-receipt API with the uploaded file URL
            return ajax({
              url: `${API_URL}/admin/utility-bills/upload-receipt`,
              method: "POST",
              headers: Headers.get_auth(), // Use JSON headers since we're sending JSON now
              body: JSON.stringify({
                payment: billId,
                receiptUrl: receiptUrl
              }),
            }).pipe(
              switchMap(({ response }) =>
                ActionsObservable.create((obs) => {
                  console.log("🎯 Upload Utility Bill Receipt Response:", response);
                  obs.next({
                    type: PropertiesStats.UPLOAD_UTILITY_BILL_RECEIPT_SUCCESS,
                    payload: {
                      billId: billId,
                      receiptUrl: receiptUrl,
                      updatedBill: response.payload || response.data,
                    },
                  });
                  if (payload?.onSuccess) payload.onSuccess(response);
                  toast.success("Receipt uploaded successfully");
                  obs.complete();
                })
              ),
              catchError((err) =>
                ActionsObservable.create((obs) => {
                  console.error("❌ Upload Utility Bill Receipt API Error:", err);
                  if (err.status === 401) {
                    localStorage.clear();
                    window.location.href = "/login";
                  }
                  toast.error(err?.response?.error || "Failed to upload receipt");
                  if (payload?.onError) payload.onError(err);
                  obs.complete();
                })
              )
            );
          }),
          catchError((err) => {
            console.error("❌ File Upload Error:", err);
            return ActionsObservable.create((obs) => {
              toast.error("Failed to upload receipt file");
              if (payload?.onError) payload.onError(err);
              obs.complete();
            });
          })
        );
      } else {
        // No file upload, just send JSON (for existing receipts)
        console.log("📋 Using existing receipt for payment:", billId);
        return ajax({
          url: `${API_URL}/admin/utility-bills/upload-receipt`,
          method: "POST",
          headers: Headers.get_auth(),
          body: JSON.stringify({
            payment: billId,
            useExistingReceipt: payload?.useExistingReceipt || false,
          }),
        }).pipe(
          switchMap(({ response }) =>
            ActionsObservable.create((obs) => {
              console.log("🎯 Upload Utility Bill Receipt Response (existing):", response);
              obs.next({
                type: PropertiesStats.UPLOAD_UTILITY_BILL_RECEIPT_SUCCESS,
                payload: {
                  billId: billId,
                  receiptUrl: payload?.receiptUrl,
                  updatedBill: response.payload || response.data,
                },
              });
              if (payload?.onSuccess) payload.onSuccess(response);
              toast.success("Receipt uploaded successfully");
              obs.complete();
            })
          ),
          catchError((err) =>
            ActionsObservable.create((obs) => {
              console.error("❌ Upload Utility Bill Receipt Error:", err);
              if (err.status === 401) {
                localStorage.clear();
                window.location.href = "/login";
              }
              toast.error(err?.response?.error || "Failed to upload receipt");
              if (payload?.onError) payload.onError(err);
              obs.complete();
            })
          )
        );
      }
    })
  );

export const runUtilityBillsBotEpic = (action$) =>
  action$.pipe(
    ofType(PropertiesStats.RUN_UTILITY_BILLS_BOT),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/utility-bills/run-bot`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({ ids: payload?.ids || [] }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            const count = response.payload?.payments?.length || 0;
            toast.success(`Bot payment started for ${count} ${count === 1 ? "bill" : "bills"}`);
            if (payload?.onSuccess) {
              payload.onSuccess(response.payload);
            }
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to start bot payment");
            if (payload?.onError) {
              payload.onError(err);
            }
            obs.complete();
          })
        )
      )
    )
  );
